namespace TabAurous.Retail {
    export namespace POSOrderService {
        export const baseUrl = 'Retail/Order';

        export declare function Create(request: Serenity.SaveRequest<POSOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSOrderRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetCustomerandProductDetails(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/Order/Create",
            Update = "Retail/Order/Update",
            Delete = "Retail/Order/Delete",
            Retrieve = "Retail/Order/Retrieve",
            GetCustomerandProductDetails = "Retail/Order/GetCustomerandProductDetails",
            List = "Retail/Order/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetCustomerandProductDetails', 
            'List'
        ].forEach(x => {
            (<any>POSOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
